<template>
  <div v-if="currentCompte">
    <div class="row">
      <div class="col-lg-6 offset-lg-6 mt-lg-4">
        <button
          type="button"
          class="btn btn-custom-primary"
          @click.prevent="
            $router
              .push({
                name: listUrl + '-edit',
                params: { id: currentCompte.id },
              })
              .catch(() => {})
          "
        >
          <i class="fa fa-edit font-size-17"></i> Modifier
        </button>
      </div>
    </div>
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12 col-lg-3">
          <div class="card mb-n1">
            <div class="card-body mb-n2">
              <div class="row">
                <div class="col-12">
                  <div
                    class="d-flex flex-column align-items-center justify-content-center text-center"
                  >
                    <img
                      v-if="currentCompte.url_image"
                      class="rounded-circle"
                      alt="Image"
                      width="200"
                      height="200"
                      :src="currentCompte.url_image"
                      data-holder-rendered="true"
                    />
                    <img
                      v-else
                      class="rounded-circle"
                      alt="Image"
                      width="200"
                      height="200"
                      :src="URL_LOCAL_FILE + '/images/no-image.png'"
                      data-holder-rendered="true"
                    />
                    <div class="mt-3">
                      <div>
                        <input
                          ref="imageUpload"
                          type="file"
                          style="display: none"
                          accept="image/*"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-9">
          <div class="card">
            <div class="row">
              <div class="col-md-12">
                <table class="table table-bordered mb-0">
                  <tbody>
                    <tr>
                      <td>
                        <i class="far fa-envelope text-custom-primary"></i>
                        <span class="font-weight-bold">
                          Email de connexion :
                        </span>
                      </td>
                      <td>
                        {{ currentCompte.email }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <i class="fa fa-language text-custom-primary"></i>
                        <span class="font-weight-bold"> Langue : </span>
                      </td>
                      <td>
                        {{
                          currentCompte.langue ? currentCompte.langue.nom : ''
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <i class="fa fa-info-circle text-custom-primary"></i>
                        <span class="font-weight-bold"> Centre de coût : </span>
                      </td>
                      <td>
                        {{
                          currentCompte.centre_cout
                            ? currentCompte.centre_cout.nom
                            : ''
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <i class="fa fa-info-circle text-custom-primary"></i>
                        <span class="font-weight-bold">
                          Peut se sonnecter ?
                        </span>
                      </td>
                      <td>
                        <b-badge
                          variant="custom-primary"
                          pill
                          v-if="currentCompte.statut"
                          class="p-2"
                        >
                          Oui
                        </b-badge>
                        <b-badge variant="danger" pill v-else class="p-2">
                          Non
                        </b-badge>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/rh/employe-compte';
import config from '@/config';
export default {
  data() {
    return {
      currentCompte: null,
      URL_LOCAL_FILE: config.URL_LOCAL_FILE,
    };
  },
  computed: {
    listUrl() {
      return this.$route.name.split('-')[0];
    },
  },
  methods: {
    init() {
      window.axios
        .get(URL.COMPTE + '/' + this.$route.params.id)
        .then((resp) => {
          this.currentCompte = resp.data.compte;
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
